import React, { useEffect, useState } from "react";
import DownloadIconSVG from "../../components/DownloadIconSVG";
import { useParams } from "react-router";
import cn from "classnames";
const API = "";

const getPosts = (id) => fetch(`${API}/api/posts/${id}`).then(r => r.json())

const getExt = (url) => {
    const match = url.match(/\.[a-zA-Z0-9]+$/);
    return match ? match[0] : "";
};

const downloadFile = async (url, filename) => {
    try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(`Не удалось скачать файл: ${res.status}`);
        const blob = await res.blob();
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
    } catch (e) {
        console.error(e);
    }
};

const Portfolio = () => {
    const params = useParams()
    const [data, setData] = useState(null)
    const [isPopUpOpen, setIsPopUpOpen] = useState(false)
    const [activeIdx, setActiveIdx] = useState(-1)
    const [isDownloadingAll, setIsDownloadingAll] = useState(false)
    const [downloadProgress, setDownloadProgress] = useState(0)
    
    useEffect(() => {
        getPosts(params.id).then(response => {
            if (response) {
                setData(response)
            } else {
                window.location.href = "https://www.instagram.com/aleenscanon/";
            }
        })
        
    }, [params.id])


    const handlePhotoClick = (idx) => {
        setIsPopUpOpen(true)
        setActiveIdx(idx)
    }

    const handleClose = () => {
        setActiveIdx(-1)
        setIsPopUpOpen(false)
    }

    const handleNext = () => {
        const nextIdx = activeIdx + 1
        setActiveIdx(nextIdx < data.images.length ? nextIdx : 0)
    }

    const handlePrev = () => {
        const prevIdx = activeIdx - 1
        setActiveIdx(prevIdx >= 0 ? prevIdx : (data.images.length - 1) )
    }

    const downloadAllFilles = async () => {
        if (isDownloadingAll) return;
        setIsDownloadingAll(true);
        setDownloadProgress(0);
        try {
            // качаем по очереди — если запустить все fetch разом, часть браузеров
            // блокирует множественные одновременные download без доп. клика юзера
            for (let i = 0; i < data.images.length; i++) {
                const photo = data.images[i];
                await downloadFile(API + photo.url, `photo-${i + 1}${getExt(photo.url)}`);
                setDownloadProgress(i + 1);
            }
        } finally {
            setIsDownloadingAll(false);
        }
    }

    function formatDate(dateString) {
        return new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
            timeZone: 'UTC',
        }).format(new Date(dateString));
    }

    if (!data) return null


    const lightboxCN = cn('lightbox', {
        'open': isPopUpOpen
    })
    console.log(data);
    
    return (
        <>
            <header className="hero">
                <img src={API + data.images[0].url} alt="Обложка съёмки" />
                <div className="hero-content">
                    <h1 style={{textAlign: "center"}}>{data.title}</h1>
                    <span style={{ textAlign: "center" }}>Photographer • aleenscanon</span>                    
                </div>

                {/* <div className="scroll-cue"><span></span><span className="line"></span></div> */}
            </header>


            <main className="gallery-section">
                <div className="gallery-head">
                    <div>
                        <div className="hero-meta">
                            {/* <span>{data.images.length} <strong> Images</strong></span> */}
                            <span> <strong>Available until: </strong>{formatDate(data.shootDate)}</span>
                        </div>
                    </div>
                    <span className="count-badge" id="countBadge">{data.images.length} / {data.images.length}</span>
                </div>

                <div className="grid" id="grid">
                    {
                        data.images.map((photo, i) => (
                            <div onClick={() => handlePhotoClick(i)} key={i} className="frame">
                                <span className="frame-index">№ {String(i + 1).padStart(2, '0')}</span>
                                <img src={API + photo.url} alt="Фото" loading="lazy"  />
                                <div className="frame-scrim">
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            downloadFile(API + photo.url, `photo-${i + 1}${getExt(photo.url)}`);
                                        }}
                                        className="dl-btn"
                                        href={API + photo.url}
                                    >
                                        <DownloadIconSVG />
                                    </a>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </main>

            <button
                onClick={downloadAllFilles}
                className="download-all"
                id="downloadAllBtn"
                disabled={isDownloadingAll}
            >
                <span className="shutter"></span>
                {isDownloadingAll
                    ? `loading… ${downloadProgress}/${data.images.length}`
                    : "Download all files"}
            </button>

            <div className={lightboxCN} id="lightbox">
                <button onClick={handleClose} className="lightbox-close">✕</button>
                <div className="lightbox-download">
                    <a
                        onClick={(e) => {
                            e.preventDefault();
                            if (activeIdx < 0 || !data.images[activeIdx]) return;
                            downloadFile(
                                API + data.images[activeIdx].url,
                                `photo-${activeIdx + 1}${getExt(data.images[activeIdx].url)}`
                            );
                        }}
                        className="dl-btn"
                        href={API + data.images[activeIdx]?.url}
                    >
                        <DownloadIconSVG />
                    </a>
                </div>
                <button onClick={handlePrev} className="lightbox-nav prev">‹</button>
                <img id="lbImg" src={API + data.images[activeIdx]?.url} alt=""/>
                <button onClick={handleNext} className="lightbox-nav next">›</button>
                <div className="lightbox-caption"></div>
            </div>
        </>
    )
}

export default Portfolio